import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // 'computed' puts the browser history back where it was when a back-button
    // navigation is cancelled (staff choosing to keep unsaved changes), so the
    // next press of Back still goes to the right page.
    //
    // Every route is lazy, so on a weak connection tapping the nav used to sit
    // there doing nothing while its chunk downloaded. Preloading pulls the rest
    // of the routes in the background once the first page is up: about 60 KB
    // all told, after which navigation is instant. The heavy xlsx parser is
    // imported inside the import services rather than by a route, so it is not
    // dragged along with this.
    provideRouter(
      routes,
      withRouterConfig({ canceledNavigationResolution: 'computed' }),
      withPreloading(PreloadAllModules),
    ),
  ]
};
